import { FileUpload } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { FileType } from 'libs/ui';
import { getToday } from 'modules/onboarding/common/helpers/getToday';

import { Field, MAX_FILES } from '../../../forms/companyConstituentDocs';

export interface FormContentProps {
  enabledDateOfLastChange: boolean;
  files?: FileUpload[];
  onAddFiles?: (file: File[]) => void;
  onRemoveFile?: (file: FileUpload) => void;
}

export const FormContent = ({
  files,
  enabledDateOfLastChange,
  onAddFiles,
  onRemoveFile,
}: FormContentProps) => {
  const { t } = useTranslation();

  return (
    <>
      {enabledDateOfLastChange && (
        <Field.DatePicker
          label={t('onboarding.companyConstituentDocs.dateOfLastChange.label')}
          maxDate={getToday()}
          name="dateOfLastChange"
          placeholder={t(
            'onboarding.companyConstituentDocs.dateOfLastChange.placeholder'
          )}
        />
      )}

      <Field.FilesUpload
        files={files}
        fileTypes={[FileType.pdf]}
        maxFiles={MAX_FILES}
        name="fileIds"
        title={t('onboarding.companyConstituentDocs.documentTitle')}
        onAddFiles={(f) => onAddFiles?.(f)}
        onRemoveFile={onRemoveFile}
      />
    </>
  );
};
